<template>
  <div>
    <b-row>
      <b-col>
        <label for="task_type" class="form-control-label">
          {{$t('views.excmtask.form.idTaskType')}}</label>
        <model-select name="task_type" :options="taskTypeOptions" v-model="item.idTaskType" required>
        </model-select>
      </b-col>
    </b-row>
    <b-col cols="12">
      <b-form-checkbox :disabled="lockSelection" class="my-1" v-model="dispatch.addToPool">
        {{ $t('views.excmtask.form.addToPool') }}
      </b-form-checkbox>
    </b-col>
    <div v-if="!dispatch.addToPool">
      <b-row v-if="taskType">
        <b-col cols="12">
          <hr class="my-1">
          <b-form-group>
            <label for="dispatchTask">{{$t('modals.excmtask.dispatchUserData')}}</label>
            <model-select :isDisabled="lockSelection || (isServiceman && taskType.canUpdate)" id="dispatchTask" v-model="dispatch.userData" :options="technicianOptions"></model-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" v-if="taskType && taskType.taskParams.canBeDailyPlanItem">
          <label
            for="userData"
            class="form-control-label">{{$t('modals.excmtask.date')}}:</label>
          <fg-input>
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="dispatch.date"
              type="date">
            </el-date-picker>
          </fg-input>
        </b-col>
        <b-col cols="6" v-if="taskType && taskType.taskParams.canBeDailyPlanItem">
          <label
            for="userData"
            class="form-control-label">{{$t('modals.excmtask.timeStartOnCalendar')}}:</label>
          <VueCtkDateTimePicker no-header
                                :label="$t('modals.excmtask.timeStartOnCalendar')"
                                v-model="dispatch.timeStartOnCalendar"
                                format="HH:mm"
                                :right="true"
                                only-time
                                formatted="HH:mm"
          >
          </VueCtkDateTimePicker>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="isLoadingCustomFields">
      <Loader></Loader>
    </b-row>
    <b-row v-if="item.customFields.length > 0 && !isLoadingCustomFields">
      <b-col>
        <hr>
        <div v-for="(customField, index) in item.customFields" v-bind:key="'customField-' + index">
          <TaskCustomFields :item="customField"></TaskCustomFields>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!item['@id'] && taskType && taskType.taskParams.canHaveDocument">
      <b-col cols="12">
        <hr>
        <p>{{ $t('buttons.uploadDocument') }}</p>
      </b-col>
      <b-col cols="12">
        <documents-to-upload-collection :file-is-optional="true" :documents-to-upload="documentsToUpload" :document-type-options="documentTypeOptions"></documents-to-upload-collection>
      </b-col>
    </b-row>
<!--    Aby nie można było zapisać zadania jeśli jeszcze nie załadowano pól własnych-->
    <b-row v-if="!isLoadingCustomFields">
      <b-col>
        <button
          @click="handleSubmit()"
          type="submit"
          class="btn btn-success">{{$t('buttons.submit')}}</button>
        <b-btn v-if="routeName === 'DailyPlanShow'" @click="closeModal()" variant="danger">{{ $t('buttons.close') }}</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import TaskCustomFields from './components/TaskCustomFields'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Loader from '@/components/Dashboard/Layout/Loader'
import { getUserRoles } from '@/utils/checkRoles'
import { ENTRYPOINT } from '@/config/entrypoint'
import ApiService from '@/utils/ApiService'
import DocumentsToUploadCollection from '@/components/Dashboard/Views/excmdevicemodel/components/UploadDocumentModal/DocumentsToUploadCollection'
import getId from '@/utils/getIdFromLink'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  components: {
    DocumentsToUploadCollection,
    TaskCustomFields,
    ModelSelect,
    Loader,
    VueCtkDateTimePicker
  },
  props: {
    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    idCase: {
      type: String,
      required: false
    },
    addTaskWithoutFinish: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'customFields' (val) {
      this.item.customFields = val
    },
    'taskType' (val) {
      if (val) {
        if (!val.canUpdate) {
          this.dispatch.addToPool = true
          this.dispatch.userData = null
        } else {
          this.dispatch.addToPool = false
          this.setCurrentUser()
        }
        if (val.taskParams.canHaveDocument) {
          this.fetchDocumentTypeOptions(val['@id'])
        } else {
          this.documentsToUpload = []
          this.setDocumentsToUpload([])
        }
        if (val.taskParams.autoDispatch === 2) { // 2 oznacza, że zadanie ma "wrócić" do osoby która miała poprzednie zadanie w puli
          this.lockSelection = true
          this.setAutoDispatchUser(val['@id'])
        } else {
          this.lockSelection = false
        }
      }
    },
    'item.idTaskType' (val) {
      this.getTaskType(val)
      this.getTechnicians(val)
    },
    taskTypeOptions (val) {
      if (val.length > 0) {
        this.proposeNextTask()
      }
    }
  },

  data () {
    return {
      dispatch: {
        addToPool: false,
        userData: '',
        date: '',
        timeStartOnCalendar: ''
      },
      documentsToUpload: [],
      documentTypeOptions: [],
      item: {
        customFields: [],
        idTaskType: null,
        idCase: null,
        addTaskWithoutFinish: this.addTaskWithoutFinish
      },
      currentCase: {},
      lockSelection: false
    }
  },

  created () {
    this.setCurrentUser()
    if (this.idCase) {
      this.item.idCase = this.idCase
    }
    this.getTaskTypeOptions()
  },
  computed: {
    isServiceman () {
      return (getUserRoles().roles.includes('ROLE_SERVICEMAN') || getUserRoles().roles.includes('ROLE_EXTERNAL_SERVICEMAN') || getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE'))
    },
    isDispatcher () {
      return !!getUserRoles().roles.includes('ROLE_DISPATCHER')
    },
    routeName () {
      return this.$route.name
    },
    violations () {
      return this.errors || {}
    },
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    ...mapGetters({
      retrievedCase: 'excmcase/show/retrieved',
      taskTypeOptions: 'excmtasktype/list/getTaskTypeOptions',
      taskType: 'excmtasktype/show/retrieved',
      customFields: 'excmtasktype/show/getCustomFields',
      isLoadingCustomFields: 'excmtasktype/show/isLoading',
      userDataList: 'userdata/list/items'
    }),
    technicianOptions () {
      return this.userDataList.map(entry => {
        return {
          value: entry['@id'],
          text: entry.fullName
        }
      })
    }
  },

  beforeDestroy () {
    this.resetTaskType()
  },

  methods: {
    setCurrentUser () {
      if (!this.isDispatcher) {
        this.dispatch.userData = this.path + 'user_datas/' + getUserRoles().id_userdata
      }
    },

    reset () {
      this.dispatch = {
        userData: '',
        date: '',
        timeStartOnCalendar: ''
      }
      this.item = {
        customFields: [],
        idTaskType: null,
        idCase: null
      }
      this.documentsToUpload = []
    },

    ...mapMutations({
      setDispatchData: 'excmtask/createModal/setDispatchData',
      setDocumentsToUpload: 'excmtask/createModal/setDocumentsToUpload',
      resetTaskType: 'excmtasktype/show/reset'
    }),

    ...mapActions({
      getTaskTypes: 'excmtasktype/list/getItems',
      fetchTaskType: 'excmtasktype/show/retrieve',
      getUserData: 'userdata/list/default'
    }),
    async setAutoDispatchUser (idTaskType) {
      let params = { idTaskTypeToAdd: idTaskType }
      const response = await new ApiService(this.idCase + '/auto_dispatch_user', params).getResults()
      if (response) {
        this.dispatch.userData = response
        this.dispatch.addToPool = false
      } else {
        this.dispatch.addToPool = true
      }
    },
    getTechnicians (idTaskType = undefined) {
      let params = { pagination: false, isCompany: 0, isContractor: 0 }
      if (idTaskType) {
        params.applicableForTaskType = idTaskType
      }
      // if (!this.isServiceman && idTaskType) {
      //   params.applicableForTaskType = idTaskType
      // }
      let link = addParamsToQuery('user_datas/list', params)
      this.getUserData(link)
    },

    getTaskTypeOptions () {
      let params = { pagination: false, state: 1 }
      if (this.idCase) {
        params.applicableForCase = this.idCase
      }
      if (this.addTaskWithoutFinish) {
        params.addTaskWithoutFinish = 1
      }
      let link = addParamsToQuery('e_x_c_m_task_types', params)
      this.getTaskTypes(link)
    },
    async fetchDocumentTypeOptions (taskTypeId) {
      let params = { pagination: false, applicableForTaskType: getId(taskTypeId) }
      const response = await new ApiService('document_types', params).getResults()
      this.documentTypeOptions = response.items.map(type => { return { value: type['@id'], text: type.title, allowedExtensions: type.allowedExtensions } })
    },
    handleSubmit () {
      this.setDispatchData(this.dispatch)
      this.setDocumentsToUpload(this.documentsToUpload)
      this.$emit('handleSubmit', this.item)
    },
    async proposeNextTask () {
      if (this.idCase) {
        await this.fetchCase(this.idCase)
      }
      if (this.currentCase.lastTask && this.currentCase.lastTask.idTaskType.idDefaultNextTask) {
        this.item.idTaskType = this.taskTypeOptions.find(option => option.value === this.currentCase.lastTask.idTaskType.idDefaultNextTask['@id']).value
      }
    },
    async fetchCase (id) {
      if (!this.retrievedCase) {
        this.currentCase = await new ApiService(id).getResults()
      } else {
        this.currentCase = this.retrievedCase
      }
    },
    closeModal () {
      this.$store.state.modals.excmtask.create.close = 1
    },
    async getTaskType (id) {
      if (id) {
        await this.fetchTaskType(id)
      }
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
